export default __webpack_public_path__ + "static/media/Monsoon-in-Pachmarhi.3acc8f9d.jpg";